import React, { useState } from "react";
import {
  Button, Dropdown, DropdownMenu, DropdownToggle, Nav,
  NavItem,
  NavLink, Tooltip
} from "reactstrap";
import Frame from "../../assets/images/svg/Frame.svg";
import Vector from "../../assets/images/svg/vector.svg";
import Wrench from "../../assets/images/svg/wrench.svg";
import Lock from "../../assets/images/svg/lock.svg";

const notifications = [
  {
    id: 1,
    title: "Speed Violation - Truck A",
    message: "Truck A exceeded speed limit by 22 km/h near Highway 66, Texas.",
    date: "15-05-2025 09:43",
    type: "danger",
  },
  {
    id: 2,
    title: "Geofence Warning - Truck C",
    message: "Truck C approached the edge of the geofenced zone in I-80, Nevada.",
    date: "15-05-2025 09:50",
    type: "warning",
  },
  {
    id: 3,
    title: "Engine Overheat - Truck B",
    message: "Truck B's engine temperature exceeded safe limits in Miami, FL.",
    date: "15-05-2025 10:01",
    type: "danger",
  },
  {
    id: 4,
    title: "Maintenance Completed - Truck D",
    message: "Scheduled maintenance for Truck D was completed successfully.",
    date: "15-05-2025 10:15",
    type: "success",
  },
  {
    id: 5,
    title: "Signal Loss Warning - Truck E",
    message: "Intermittent GPS signal detected in rural area near Route 93.",
    date: "15-05-2025 10:27",
    type: "warning",
  },
  {
    id: 6,
    title: "Fuel Efficiency Improved - Truck C",
    message: "Truck C reported a 12% improvement in fuel usage this week.",
    date: "15-05-2025 10:35",
    type: "success",
  },
];

const wialonNotifications = [
  {
    id: 1,
    title: "Truck E GPS Signal Lost",
    text: "Truck E has lost GPS signal for over 10 minutes.",
    controlType: "GPS",
    parameters: "Signal Loss",
    activation: 21,
    units: 25,
    action: 1,
  },
  {
    id: 2,
    title: "Truck B Fuel Level Low",
    text: "Truck B has 10% fuel remaining.",
    controlType: "Fuel Level",
    parameters: "Low Fuel",
    activation: "23",
    units: 30,
    action: 2,
  },
  {
    id: 3,
    title: "Truck E GPS Signal Lost",
    text: "Truck E has lost GPS signal for over 10 minutes.",
    controlType: "GPS",
    parameters: "Signal Loss",
    activation: 21,
    units: 25,
    action: 1,
  },
  {
    id: 4,
    title: "Truck E GPS Signal Lost",
    text: "Truck E has lost GPS signal for over 10 minutes.",
    controlType: "GPS",
    parameters: "Signal Loss",
    activation: 21,
    units: 25,
    action: 1,
  },
  {
    id: 5,
    title: "Truck E GPS Signal Lost",
    text: "Truck E has lost GPS signal for over 10 minutes.",
    controlType: "GPS",
    parameters: "Signal Loss",
    activation: 21,
    units: 25,
    action: 1,
  },

];

const toolTip = [
  { unit_id: 2719, unit_name: "LOCK 1" },
  { unit_id: 2720, unit_name: "Lock 02" },
  { unit_id: 2999, unit_name: "Lock 03" },
  { unit_id: 3000, unit_name: "04 - GL03KNG" },
  { unit_id: 3001, unit_name: "05 - lucchetto" },
  { unit_id: 3002, unit_name: "06 - SC329ES" },
  { unit_id: 3003, unit_name: "07  Miron" },
  { unit_id: 3004, unit_name: "09 - FL767GN -  GRADINARU" },
  { unit_id: 3005, unit_name: "09 GN866GA" },
  { unit_id: 3006, unit_name: "10 - GL01KNG" },
  { unit_id: 3007, unit_name: "11 - FS919NF" },
  { unit_id: 3008, unit_name: "12 - GV394MY" },
  { unit_id: 3009, unit_name: "13 - GR835PX" },
  { unit_id: 3010, unit_name: "14 GK968EN" },
  { unit_id: 3011, unit_name: "15 GM996MG" },
  { unit_id: 3012, unit_name: "16 - ex GP785CT  PIRVU IONUT GJ74KB" },
  { unit_id: 3013, unit_name: "17 - FG500RC" },
  { unit_id: 3014, unit_name: "18 - GL67TMA" },
  { unit_id: 3015, unit_name: "19 - GE978KB" },
  { unit_id: 3017, unit_name: "21 - GM994MG" },
  { unit_id: 3019, unit_name: "Lock 22" }
]


const NotificationDropdown = () => {
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState("Platfrom");
  const [tooltipOpenId, setTooltipOpenId] = useState(null);
  const [actionTooltipOpenId, setActionTooltipOpenId] = useState(null);


  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const toggleActionTooltip = (id) => {
    setActionTooltipOpenId((prev) => (prev === id ? null : id));
  };


  const toggleTooltip = (id) => {
    setTooltipOpenId((prev) => (prev === id ? null : id));
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="bx bx-bell fs-22"></i>
          <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
            {notifications.length}
            <span className="visually-hidden">unread messages </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end notificationDropdown">
          <div className="d-flex justify-content-between align-items-center mb-2 mb-sm-4">
            <span className="notificationText">Notifications</span>
            <p className="markReadText">Must read</p>
          </div>

          <div className="activeTabContent">
            <Nav tabs className="headerTabs">
              <NavItem>
                <NavLink
                  onClick={() => {
                    setActiveTab("Platfrom");
                  }}
                  className={activeTab === "Platfrom" ? "active-tab" : ""}
                >
                  Platfrom
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  onClick={() => {
                    setActiveTab("Wialon");
                  }}
                  className={activeTab === "Wialon" ? "active-tab" : ""}
                >
                  Wialon
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          {/* Notification Platform Content */}
          {activeTab === "Platfrom" ? (
            <div className="notificationContent">
              {notifications.map((element, index) => {
                return (
                  <div className="notificationCard" key={index}>
                    <div className="notificationDetails">
                      <span className="notifyNumber">{element.title}</span>
                      <span className="notifyDescription">{element.message}</span>
                      <span className="notifyTime">{element.date}</span>
                    </div>
                    <div className="notificationStatus">
                      <Button className="notifyStatus" color={element.type}>
                        Expiration
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="notificationContent">

              <div className="notificationContent">
                {wialonNotifications.map((item) => (
                  <div className="notificationCard" key={item.id}>
                    <div className="notificationDetails w-100">
                      <span className="notifyTitle">{item.title}</span>
                      <div className="d-flex justify-content-between gap-4">
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex gap-2">
                            <span className="notifyLabel">Text:</span>
                            <span className="notifyValue">{item.text}</span>
                          </div>
                          <div className="d-flex gap-2">
                            <span className="notifyLabel">Control Type:</span>
                            <span className="notifyValue">{item.controlType}</span>
                          </div>
                          <div className="d-flex gap-2">
                            <span className="notifyLabel">Parameters:</span>
                            <span className="notifyValue">{item.parameters}</span>
                          </div>
                        </div>

                        <div className="d-flex flex-column  gap-2">
                          <div className="d-flex gap-2">
                            <span><img src={Vector} alt="Vector Icon" style={{ width: "18px", height: "18px" }} /></span>
                            <span className="notifyValue">Activation {" "}({item.activation})</span>
                          </div>
                          <div
                            className="d-flex gap-2 tooltip-trigger"
                            style={{ position: "relative" }}
                          >
                            <span>
                              <img src={Wrench} alt="Wrench Icon" style={{ width: "18px", height: "18px" }} />
                            </span>
                            <span
                              className="notifyValue"
                              id={`units-tooltip-${item.id}`}
                              style={{ cursor: "pointer" }}
                            >
                              Units ({item.units})
                            </span>

                            <Tooltip
                              placement="bottom"
                              isOpen={tooltipOpenId === item.id}
                              target={`units-tooltip-${item.id}`}
                              toggle={() => toggleTooltip(item.id)}
                              className="tooltip-inner"
                              autohide={false}
                            >
                              <div className="d-flex justify-content-between gap-4">
                                <div className="d-flex flex-column gap-1">
                                  {toolTip.slice(0, Math.ceil(toolTip.length / 2)).map((unit) => (
                                    <div className="d-flex gap-2">
                                      <span><img src={Lock} alt="Lock Icon" style={{ width: "18px", height: "18px" }} /></span>
                                      <span key={unit.unit_id}>{unit.unit_name}</span>
                                    </div>
                                  ))}
                                </div>
                                <div className="d-flex flex-column gap-1">
                                  {toolTip.slice(Math.ceil(toolTip.length / 2)).map((unit) => (
                                    <div className="d-flex gap-2">
                                      <span><img src={Lock} alt="Lock Icon" style={{ width: "18px", height: "18px" }} /></span>
                                      <span key={unit.unit_id}>{unit.unit_name}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </Tooltip>
                          </div>

                          <div className="d-flex gap-2 tooltip-trigger" style={{ position: "relative" }}>
                            <span>
                              <img src={Frame} alt="Frame Icon" style={{ width: "18px", height: "18px" }} />
                            </span>
                            <span
                              className="notifyValue"
                              id={`action-tooltip-${item.id}`}
                              style={{ cursor: "pointer" }}
                            >
                              Action ({item.action})
                            </span>

                            <Tooltip
                              placement="bottom"
                              isOpen={actionTooltipOpenId === item.id}
                              target={`action-tooltip-${item.id}`}
                              toggle={() => toggleActionTooltip(item.id)}
                              className="tooltip-inner"
                              autohide={false}
                            >
                             <span>Send email to : Admin@gmail.com </span>
                            </Tooltip>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>


            </div>
          )}


        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
